import View from './view'

export const Sitemap = View
